/**
 * @file jsonp跨域请求
 * @author quda
 *
 * @param {string} url 请求url
 * @param {Object} param 请求参数
 * @param {Function} callback 回调函数
 * @return {boolean} false
 */

const jsonp = (url, param, options) => {
    let timer;
    let script;
    let target;
    let query = '';

    const queries = [];
    const md5 = Math.ceil(Math.random() * 100000);
    const callbackName = 'jsonp' + md5;
    const mark = url.indexOf('?') > 0 ? '&' : '?';
    const defaultOptions = {
        jsonpCallback: 'jsonp', // 全局回调函数前缀
        timeout: 50000, // 默认超时时间
        jsonp: 'callback' // JSONP回调查询参数的名称
    };

    // To do 解决安卓低版本无法打开
    if (typeof Object.assign !== 'function') {
        // Must be writable: true, enumerable: false, configurable: true
        Object.defineProperty(Object, 'assign', {
            value: function assign(target, varArgs) {
                // .length of function is 2
                'use strict';
                if (target == null) {
                    // TypeError if undefined or null
                    throw new TypeError('Cannot convert undefined or null to object');
                }

                let to = Object(target);

                for (var index = 1; index < arguments.length; index++) {
                    var nextSource = arguments[index];

                    if (nextSource != null) {
                        // Skip over if undefined or null
                        for (let nextKey in nextSource) {
                            // Avoid bugs when hasOwnProperty is shadowed
                            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                                to[nextKey] = nextSource[nextKey];
                            }
                        }
                    }
                }
                return to;
            },
            writable: true,
            configurable: true
        });
    }

    options = Object.assign({}, defaultOptions, options);

    for (let key in param) {
        if ({}.hasOwnProperty.call(param, key)) {
            if (typeof param[key] === 'object') {
                query = key + '=' + JSON.stringify(param[key]);
            } else {
                query = key + '=' + param[key];
            }
            queries.push(query);
        }
    }

    url += mark + queries.join('&');

    target = document.getElementsByTagName('script')[0] || document.head;
    url = url + '&' + options.jsonp + '=' + callbackName;
    script = document.createElement('script');
    script.src = url;
    script.type = 'text/javascript';
    target.parentNode.appendChild(script, target);
    function clean() {
        script.parentNode && script.parentNode.removeChild(script);
        timer && clearTimeout(timer);
        window[callbackName] = null;
    }

    return new Promise((resolve, reject) => {
        window[callbackName] = function (data) {
            if (data && 'string' === typeof data) {
                try {
                    data = JSON.parse(data);
                } catch (e) {
                    data = {};
                    console.error('[ERROR] Parse Error.');
                }
            }
            resolve(data);
            clean();
        };

        // 加载错误
        script.onerror = function (err) {
            clean();
            reject({
                errno: -2,
                errmsg: `[ERROR] Load Error: ${err}`,
                data: {}
            });
        };

        // 超时
        if (options.timeout) {
            timer = setTimeout(() => {
                clean();
                reject({
                    errno: -3,
                    errmsg: '[ERROR] Time out.',
                    data: {}
                });
            }, options.timeout);
        }
    });
};

export default jsonp;
